import { useMemo } from 'react';
import type { Theme } from '../types';

export const TOKENS = {
  paper: '#f4eedf',
  paperDark: '#3a2f27',
  card: '#fbf6ec',
  cardDark: '#48392f',
  ink: '#1f1a17',
  inkDark: '#f4ead7',
  muted: '#7a6f60',
  mutedDark: '#b5a78f',
  rule: 'rgba(31, 26, 23, 0.10)',
  ruleDark: 'rgba(244, 234, 215, 0.14)',
  terracotta: '#d97757',
  moss: '#7a8a4c',
  rose: '#c98b7a',
  butter: '#e8c66e',
  sky: '#8fa9b8',
  kw: '#b9461e',
  comment: '#a89c8c',
  fn: '#6b5a3a',
} as const;

export function useTheme({ dark, accent }: { dark: boolean; accent: string }): Theme {
  return useMemo(
    () => ({
      bg: dark ? TOKENS.paperDark : TOKENS.paper,
      card: dark ? TOKENS.cardDark : TOKENS.card,
      fg: dark ? TOKENS.inkDark : TOKENS.ink,
      muted: dark ? TOKENS.mutedDark : TOKENS.muted,
      rule: dark ? TOKENS.ruleDark : TOKENS.rule,
      acc: accent || TOKENS.terracotta,
      moss: TOKENS.moss,
      rose: TOKENS.rose,
      butter: TOKENS.butter,
      sky: TOKENS.sky,
      dark,
    }),
    [dark, accent],
  );
}
